import { environment } from "@environments/environment";

const PROD_PATHS = {
  "": "rappi.com",
  MX: "rappi.com.mx",
  BR: "rappi.com.br",
  AR: "rappi.com.ar",
  CO: "rappi.com.co",
  CL: "rappi.cl",
  EC: "rappi.com.ec",
  PE: "rappi.com.pe",
  UY: "rappi.com.uy",
  CR: "rappi.co.cr",
};

const code = environment.code;

const getBundlePath = (mf, code = "") => {
  const domain = PROD_PATHS[code];
  return `https://${mf}.${domain}/static/js/bundle.js`;
};

export const MICRO_FRONTENDS = {
  dev: {
    fake_orders: {
      name: "fake_orders",
      src: "https://tmf-fake-orders.dev.rappi.com/static/js/bundle.js",
    },
    users: {
      name: "users",
      src: "https://tmf-users.dev.rappi.com/static/js/bundle.js",
    },
    order_tracking: {
      name: "order_tracking",
      src: "https://tmf-order-tracking.dev.rappi.com/static/js/bundle.js",
    },
    realtime_fo: {
      name: "realtime_fo",
      src: "https://tmf-realtime-fo.dev.rappi.com/static/js/bundle.js",
    },
    control_panel: {
      name: "control_panel",
      src: "https://tmf-control-panel.dev.rappi.com/static/js/bundle.js",
    },
    accuracy_tracker: {
      name: "accuracy_tracker",
      src: "https://tmf-accuracy-tracker.dev.rappi.com/static/js/bundle.js",
    },
    cargo_invoice: {
      name: "cargo_invoice",
      src: "https://turbo-utils-mf.dev.rappi.com/static/js/bundle.js",
    },
    bulk_upload: {
      name: "bulk-upload",
      src: "https://turbo-bulk-upload-mf.dev.rappi.com/static/js/bundle.js",
    },
    charm_price: {
      name: "charm-price",
      src: "https://turbo-charm-price-mf.dev.rappi.com/static/js/bundle.js",
    },
    sell_pricing: {
      name: "sell-pricing",
      src: "https://turbo-sell-pricing-mf.dev.rappi.com/static/js/bundle.js",
    },
    promotion: {
      name: "promotion",
      src: "https://turbo-promotions-mf.dev.rappi.com/static/js/bundle.js",
    },
    promotions_v2: {
      name: "promotions-v2",
      src: "https://turbo-promotions-new-mf.dev.rappi.com/static/js/bundle.js",
    },
    markups: {
      name: "markups",
      src: "https://turbo-markups-mf.dev.rappi.com/static/js/bundle.js",
    },
    rotation_manager: {
      name: "rotation_manager",
      src: "https://turbo-rotation-mgr-mf.dev.rappi.com/static/js/bundle.js",
    },
    competitive: {
      name: "competitive",
      src: "https://turbo-competitive-mf.dev.rappi.com/static/js/bundle.js",
    },
    wishlist: {
      name: "wishlist",
      src: "https://turbo-wishlist-mf.dev.rappi.com/static/js/bundle.js",
    },
    packs: {
      name: "packs",
      src: "https://turbo-packs-mf.dev.rappi.com/static/js/bundle.js",
    },
    label_manager: {
      name: "label_manager",
      src: "https://turbo-label-manager-mf.dev.rappi.com/static/js/bundle.js",
    },
    "price-manager": {
      name: "price-manager",
      src: "https://price-manager-mf.dev.rappi.com/static/js/bundle.js",
    },
    "purchase-plans": {
      name: "purchase-plans",
      src: "https://turbo-purchase-plans-mf.dev.rappi.com/static/js/bundle.js",
    },
    pricing: {
      name: "pricing",
      src: "https://turbo-pricing-mf.dev.rappi.com/static/js/bundle.js",
    },
    purchase_orders: {
      name: "purchase_orders",
      src: "https://turbo-purchase-orders-mf.dev.rappi.com/static/js/bundle.js",
    },
    consignment_orders: {
      name: "consignment_orders",
      src: "https://turbo-consignment-mf.dev.rappi.com/static/js/bundle.js",
    },
    po_calendar: {
      name: "po_calendar",
      src: "https://turbo-po-calendar-mf.dev.rappi.com/static/js/bundle.js",
    },
    pos: {
      name: "pos",
      src: "https://turbo-pos-mf.dev.rappi.com/static/js/bundle.js",
    },
    financial_managment: {
      name: "financial_managment",
      src: "https://turbo-purchase-orders-mf.dev.rappi.com/static/js/bundle.js",
    },
    replenishment: {
      name: "replenishment",
      src: "https://turbo-replenishment-mf.dev.rappi.com/static/js/bundle.js",
    },
    roles: {
      name: "roles",
      src: "https://turbo-roles-mf.dev.rappi.com/static/js/bundle.js",
    },
    sc_approval: {
      name: "sc_approval",
      src: "https://turbo-sc-approval-mf.dev.rappi.com/static/js/bundle.js",
    },
    transformations: {
      name: "transformations",
      src: "https://turbo-transformations-mf.dev.rappi.com/static/js/bundle.js",
    },
    inventory_savvy: {
      name: "inventory_savvy",
      src: "https://turbo-inventory-savvy-mf.dev.rappi.com/static/js/bundle.js",
    },
    supply_purchase_orders: {
      name: "supply_purchase_orders",
      src: "https://turbo-pt-order-mf.dev.rappi.com/static/js/bundle.js",
    },
    supply_transfer_orders: {
      name: "supply_transfer_orders",
      src: "https://turbo-pt-order-mf.dev.rappi.com/static/js/bundle.js",
    },
    supply_consignment_orders: {
      name: "supply_consignment_orders",
      src: "https://turbo-pt-order-mf.dev.rappi.com/static/js/bundle.js",
    },
    audit_inventory: {
      name: "audit_inventory",
      src: "https://turbo-audit-inventory-mf.dev.rappi.com/static/js/bundle.js",
    },
    campaign: {
      name: "campaign",
      src: "https://turbo-campaign-mf.dev.rappi.com/static/js/bundle.js",
    },
    multibrand: {
      name: "multibrand",
      src: "https://turbo-multibrand-mf.dev.rappi.com/static/js/bundle.js",
    },
    permissions: {
      name: "permissions",
      src: "https://turbo-permissions-mf.dev.rappi.com/static/js/bundle.js",
    },
    audit_report: {
      name: "audit_report",
      src: "https://turbo-audit-report-mf.dev.rappi.com/static/js/bundle.js",
    },
    assignments: {
      name: "assignments",
      src: "https://turbo-assignments-mf.dev.rappi.com/static/js/bundle.js",
    },
    cold_products: {
      name: "cold_products",
      src: "https://turbo-cold-products.dev.rappi.com/static/js/bundle.js",
    },
    cyclics: {
      name: "cyclics",
      src: "https://turbo-cyclics-mf.dev.rappi.com/static/js/bundle.js",
    },
    catalog: {
      name: "catalog",
      src: "https://turbo-catalog-mf.dev.rappi.com/static/js/bundle.js",
    },
    warehouse_config: {
      name: "warehouse_config",
      src: "https://turbo-warehouses-mf.dev.rappi.com/static/js/bundle.js",
    },
    kpis: {
      name: "kpis",
      src: "https://turbo-kpis-mf.dev.rappi.com/static/js/bundle.js",
    },
    price_list: {
      name: "price_list",
      src: "https://turbo-price-list-mf.dev.rappi.com/static/js/bundle.js",
    },
    catman_price_list: {
      name: "catman_price_list",
      src: "https://turbo-catman-price-list-mf.dev.rappi.com/static/js/bundle.js",
    },
    order_monitoring: {
      name: "order_monitoring",
      src: "https://turbo-order-monitoring.dev.rappi.com/static/js/bundle.js",
    },
    query_invoices: {
      name: "query_invoices",
      src: "https://turbo-query-invoices-mf.dev.rappi.com/static/js/bundle.js",
    },
    approval_request: {
      name: "approval_request",
      src: "https://turbo-approval-request.dev.rappi.com/static/js/bundle.js",
    },
    categories: {
      name: "categories",
      src: "https://turbo-categories-mf.dev.rappi.com/static/js/bundle.js",
    },
    parameters: {
      name: "parameters",
      src: "https://turbo-parameters-mf.dev.rappi.com/static/js/bundle.js",
    },
    onboarding: {
      name: "onboarding",
      src: "https://turbo-onboarding-mf.dev.rappi.com/static/js/bundle.js",
    },
    self_onboarding: {
      name: "self_onboarding",
      src: "https://turbo-self-onboarding-mf.dev.rappi.com/static/js/bundle.js",
    },
    picker_schedule: {
      name: "picker_schedule",
      src: "https://turbo-picker-schedule-mf.dev.rappi.com/static/js/bundle.js",
    },
    commercial_agreements: {
      name: "commercial_agreements",
      src: "https://turbo-supplier-admin-mf.dev.rappi.com/static/js/bundle.js",
    },
    payment_back_margins: {
      name: "payment_back_margins",
      src: "https://turbo-back-margins-mf.dev.rappi.com/static/js/bundle.js",
    },
    supplier_management: {
      name: "supplier_management",
      src: "https://turbo-supplier-manage-mf.dev.rappi.com/static/js/bundle.js",
    },
    product_visibility: {
      name: "product_visibility",
      src: "https://turbo-product-visibility-mf.dev.rappi.com/static/js/bundle.js",
    },
    supplier_metrics: {
      name: "supplier-metric",
      src: "https://turbo-sp-metrics-mf.dev.rappi.com/static/js/bundle.js",
    },
    priori_schedule_cd: {
      name: "priori_schedule_cd",
      src: "https://turbo-priori-schedule-mf.dev.rappi.com/static/js/bundle.js",
    },
  },
  prod: {
    fake_orders: {
      name: "fake_orders",
      src: getBundlePath("tmf-fake-orders", code),
    },
    users: {
      name: "users",
      src: getBundlePath("tmf-users", code),
    },
    order_tracking: {
      name: "order_tracking",
      src: getBundlePath("tmf-order-tracking"),
    },
    realtime_fo: {
      name: "realtime_fo",
      src: getBundlePath("tmf-realtime-fo"),
    },
    control_panel: {
      name: "control_panel",
      src: getBundlePath("tmf-control-panel"),
    },
    accuracy_tracker: {
      name: "accuracy_tracker",
      src: getBundlePath("tmf-accuracy-tracker"),
    },
    cargo_invoice: {
      name: "cargo_invoice",
      src: getBundlePath("turbo-utils-mf", code),
    },
    bulk_upload: {
      name: "bulk-upload",
      src: getBundlePath("turbo-bulk-upload-mf", code),
    },
    charm_price: {
      name: "charm-price",
      src: getBundlePath("turbo-charm-price-mf", code),
    },
    sell_pricing: {
      name: "sell-pricing",
      src: getBundlePath("turbo-sell-pricing-mf", code),
    },
    promotion: {
      name: "promotion",
      src: getBundlePath("turbo-promotions-mf", code),
    },
    markups: {
      name: "markups",
      src: getBundlePath("turbo-markups-mf", code),
    },
    rotation_manager: {
      name: "rotation_manager",
      src: getBundlePath("turbo-rotation-mgr-mf", code),
    },
    promotions_v2: {
      name: "promotions-v2",
      src: getBundlePath("turbo-promotions-new-mf", code),
    },
    competitive: {
      name: "competitive",
      src: getBundlePath("turbo-competitive-mf", code),
    },
    wishlist: {
      name: "wishlist",
      src: getBundlePath("turbo-wishlist-mf", code),
    },
    packs: {
      name: "packs",
      src: getBundlePath("turbo-packs-mf", code),
    },
    label_manager: {
      name: "label_manager",
      src: getBundlePath("turbo-label-manager-mf", code),
    },
    "price-manager": {
      name: "price-manager",
      src: getBundlePath("price-manager-mf", code),
    },
    "purchase-plans": {
      name: "purchase-plans",
      src: getBundlePath("turbo-purchase-plans-mf", code),
    },
    pricing: {
      name: "pricing",
      src: getBundlePath("turbo-pricing-mf", code),
    },
    purchase_orders: {
      name: "purchase_orders",
      src: getBundlePath("turbo-purchase-orders-mf", code),
    },
    consignment_orders: {
      name: "consignment_orders",
      src: getBundlePath("turbo-consignment-mf", code),
    },
    po_calendar: {
      name: "po_calendar",
      src: getBundlePath("turbo-po-calendar-mf", code),
    },
    pos: {
      name: "pos",
      src: getBundlePath("turbo-pos-mf", code),
    },
    financial_managment: {
      name: "financial_managment",
      src: getBundlePath("turbo-purchase-orders-mf", code),
    },
    replenishment: {
      name: "replenishment",
      src: getBundlePath("turbo-replenishment-mf", code),
    },
    roles: {
      name: "roles",
      src: getBundlePath("turbo-roles-mf", code),
    },
    permissions: {
      name: "permissions",
      src: getBundlePath("turbo-permissions-mf", code),
    },
    audit_report: {
      name: "audit_report",
      src: getBundlePath("turbo-audit-report-mf", code),
    },
    sc_approval: {
      name: "sc_approval",
      src: getBundlePath("turbo-sc-approval-mf", code),
    },
    transformations: {
      name: "transformations",
      src: getBundlePath("turbo-transformations-mf", code),
    },
    inventory_savvy: {
      name: "inventory_savvy",
      src: getBundlePath("turbo-inventory-savvy-mf", code),
    },
    supply_purchase_orders: {
      name: "supply_purchase_orders",
      src: getBundlePath("turbo-pt-order-mf", code),
    },
    supply_transfer_orders: {
      name: "supply_transfer_orders",
      src: getBundlePath("turbo-pt-order-mf", code),
    },
    supply_consignment_orders: {
      name: "supply_consignment_orders",
      src: getBundlePath("turbo-pt-order-mf", code),
    },
    audit_inventory: {
      name: "audit_inventory",
      src: getBundlePath("turbo-audit-inventory-mf", code),
    },
    campaign: {
      name: "campaign",
      src: getBundlePath("turbo-campaign-mf", code),
    },
    multibrand: {
      name: "multibrand",
      src: getBundlePath("turbo-multibrand-mf", code),
    },
    assignments: {
      name: "assignments",
      src: getBundlePath("turbo-assignments-mf", code),
    },
    cold_products: {
      name: "cold_products",
      src: getBundlePath("turbo-cold-products", code),
    },
    cyclics: {
      name: "cyclics",
      src: getBundlePath("turbo-cyclics-mf", code),
    },
    catalog: {
      name: "catalog",
      src: getBundlePath("turbo-catalog-mf", code),
    },
    warehouse_config: {
      name: "warehouse_config",
      src: getBundlePath("turbo-warehouses-mf", code),
    },
    kpis: {
      name: "kpis",
      src: getBundlePath("turbo-kpis-mf", code),
    },
    price_list: {
      name: "price_list",
      src: getBundlePath("turbo-price-list-mf", code),
    },
    catman_price_list: {
      name: "catman_price_list",
      src: getBundlePath("turbo-catman-price-list-mf", code),
    },
    order_monitoring: {
      name: "order_monitoring",
      src: getBundlePath("turbo-order-monitoring", code),
    },
    query_invoices: {
      name: "query_invoices",
      src: getBundlePath("turbo-query-invoices-mf", code),
    },
    approval_request: {
      name: "approval_request",
      src: getBundlePath("turbo-approval-request", code),
    },
    categories: {
      name: "categories",
      src: getBundlePath("turbo-categories-mf", code),
    },
    parameters: {
      name: "parameters",
      src: getBundlePath("turbo-parameters-mf", code),
    },
    onboarding: {
      name: "onboarding",
      src: getBundlePath("turbo-onboarding-mf", code),
    },
    self_onboarding: {
      name: "self_onboarding",
      src: getBundlePath("turbo-self-onboarding-mf", code),
    },
    picker_schedule: {
      name: "picker_schedule",
      src: getBundlePath("turbo-picker-schedule-mf", code),
    },
    commercial_agreements: {
      name: "commercial_agreements",
      src: getBundlePath("turbo-supplier-admin-mf", code),
    },
    payment_back_margins: {
      name: "payment_back_margins",
      src: getBundlePath("turbo-back-margins-mf", code),
    },
    supplier_management: {
      name: "supplier_management",
      src: getBundlePath("turbo-supplier-manage-mf", code),
    },
    product_visibility: {
      name: "product_visibility",
      src: getBundlePath("turbo-product-visibility-mf", code),
    },
    supplier_metrics: {
      name: "supplier_metric",
      src: getBundlePath("turbo-sp-metrics-mf", code),
    },
    priori_schedule_cd: {
      name: "priori_schedule_cd",
      src: getBundlePath("turbo-priori-schedule-mf", code),
    },
  },
  local: {
    fake_orders: {
      name: "fake_orders",
      src: "http://localhost:5000/static/js/bundle.js",
    },
    users: {
      name: "users",
      src: "http://localhost:5100/static/js/bundle.js",
    },
    order_tracking: {
      name: "order_tracking",
      src: "http://localhost:5200/static/js/bundle.js",
    },
    realtime_fo: {
      name: "realtime_fo",
      src: "http://localhost:5300/static/js/bundle.js",
    },
    control_panel: {
      name: "control_panel",
      src: "http://localhost:5400/static/js/bundle.js",
    },
    accuracy_tracker: {
      name: "accuracy_tracker",
      src: "http://localhost:5600/static/js/bundle.js",
    },
    cargo_invoice: {
      name: "cargo_invoice",
      src: "http://localhost:5700/static/js/bundle.js",
    },
    bulk_upload: {
      name: "bulk-upload",
      src: "http://localhost:5900/static/js/bundle.js",
    },
    charm_price: {
      name: "charm-price",
      src: "https://turbo-sell-pricing-mf.dev.rappi.com/static/js/bundle.js",
    },
    sell_pricing: {
      name: "sell-pricing",
      src: "http://localhost:3000/static/js/bundle.js",
    },
    promotion: {
      name: "promotion",
      src: "http://localhost:5000/static/js/bundle.js",
    },
    promotions_v2: {
      name: "promotions-v2",
      src: "http://localhost:5050/static/js/bundle.js",
    },
    markups: {
      name: "markups",
      src: "http://localhost:5000/static/js/bundle.js",
    },
    rotation_manager: {
      name: "rotation_manager",
      src: "http://localhost:5000/static/js/bundle.js",
    },
    competitive: {
      name: "competitive",
      src: "http://localhost:5000/static/js/bundle.js",
    },
    wishlist: {
      name: "wishlist",
      src: "http://localhost:5800/static/js/bundle.js",
    },
    packs: {
      name: "packs",
      src: "http://localhost:5801/static/js/bundle.js",
    },
    label_manager: {
      name: "label_manager",
      src: "http://localhost:5801/static/js/bundle.js",
    },
    "price-manager": {
      name: "price-manager",
      src: "http://localhost:5809/static/js/bundle.js",
    },
    "purchase-plans": {
      name: "purchase-plans",
      src: "http://localhost:5810/static/js/bundle.js",
    },
    pricing: {
      name: "pricing",
      src: "http://localhost:5803/static/js/bundle.js",
    },
    purchase_orders: {
      name: "purchase_orders",
      src: "http://localhost:5001/static/js/bundle.js",
    },
    consignment_orders: {
      name: "consignment_orders",
      src: "http://localhost:5090/static/js/bundle.js",
    },
    po_calendar: {
      name: "po_calendar",
      src: "http://localhost:5003/static/js/bundle.js",
    },
    pos: {
      name: "pos",
      src: "http://localhost:5007/static/js/bundle.js",
    },
    financial_managment: {
      name: "financial_managment",
      src: "http://localhost:5005/static/js/bundle.js",
    },
    roles: {
      name: "roles",
      src: "http://localhost:5006/static/js/bundle.js",
    },
    replenishment: {
      name: "replenishment",
      src: "http://localhost:5001/static/js/bundle.js",
    },
    sc_approval: {
      name: "sc_approval",
      src: "http://localhost:5008/static/js/bundle.js",
    },
    transformations: {
      name: "transformations",
      src: "http://localhost:5009/static/js/bundle.js",
    },
    inventory_savvy: {
      name: "inventory_savvy",
      src: "http://localhost:5009/static/js/bundle.js",
    },
    supply_purchase_orders: {
      name: "supply_purchase_orders",
      src: "http://localhost:5009/static/js/bundle.js",
    },
    supply_transfer_orders: {
      name: "supply_transfer_orders",
      src: "http://localhost:5009/static/js/bundle.js",
    },
    supply_consignment_orders: {
      name: "supply_consignment_orders",
      src: "http://localhost:5009/static/js/bundle.js",
    },
    audit_inventory: {
      name: "audit_inventory",
      src: "http://localhost:5011/static/js/bundle.js",
    },
    campaign: {
      name: "campaign",
      src: "http://localhost:5011/static/js/bundle.js",
    },
    multibrand: {
      name: "multibrand",
      src: "http://localhost:5011/static/js/bundle.js",
    },
    permissions: {
      name: "permissions",
      src: "http://localhost:5012/static/js/bundle.js",
    },
    audit_report: {
      name: "audit_report",
      src: "http://localhost:5013/static/js/bundle.js",
    },
    assignments: {
      name: "assignments",
      src: "http://localhost:5015/static/js/bundle.js",
    },
    cyclics: {
      name: "cyclics",
      src: "http://localhost:5016/static/js/bundle.js",
    },
    cold_products: {
      name: "cold_products",
      src: "http://localhost:5014/static/js/bundle.js",
    },
    catalog: {
      name: "catalog",
      src: "http://localhost:5018/static/js/bundle.js",
    },
    warehouse_config: {
      name: "warehouse_config",
      src: "http://localhost:5019/static/js/bundle.js",
    },
    kpis: {
      name: "kpis",
      src: "http://localhost:5020/static/js/bundle.js",
    },
    price_list: {
      name: "price_list",
      src: "http://localhost:5021/static/js/bundle.js",
    },
    catman_price_list: {
      name: "catman_price_list",
      src: "http://localhost:5022/static/js/bundle.js",
    },
    order_monitoring: {
      name: "order_monitoring",
      src: "http://localhost:5023/static/js/bundle.js",
    },
    query_invoices: {
      name: "query_invoices",
      src: "http://localhost:5024/static/js/bundle.js",
    },
    approval_request: {
      name: "approval_request",
      src: "http://localhost:5025/static/js/bundle.js",
    },
    categories: {
      name: "categories",
      src: "http://localhost:5026/static/js/bundle.js",
    },
    parameters: {
      name: "parameters",
      src: "http://localhost:5027/static/js/bundle.js",
    },
    onboarding: {
      name: "onboarding",
      src: "http://localhost:5028/static/js/bundle.js",
    },
    self_onboarding: {
      name: "self_onboarding",
      src: "https://turbo-self-onboarding-mf.dev.rappi.com/static/js/bundle.js",
    },
    picker_schedule: {
      name: "picker_schedule",
      src: "http://localhost:5031/static/js/bundle.js",
    },
    supplier_management: {
      name: "supplier_management",
      src: "http://localhost:5032/static/js/bundle.js",
    },
    payment_back_margins: {
      name: "payment_back_margins",
      src: "http://localhost:5033/static/js/bundle.js",
    },
    commercial_agreements: {
      name: "commercial_agreements",
      src: "http://localhost:5034/static/js/bundle.js",
    },
    product_visibility: {
      name: "product_visibility",
      src: "http://localhost:3000/static/js/bundle.js",
    },
    supplier_metrics: {
      name: "supplier_metric",
      src: "http://localhost:5035/static/js/bundle.js",
    },
    priori_schedule_cd: {
      name: "priori_schedule_cd",
      src: "http://localhost:5036/static/js/bundle.js",
    },
  },
};
